import { Button } from '@doda/io-react/common';
import { useSelector } from 'react-redux';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { loginStatusSelector } from '@doda/common/src/redux/features/memberInfo';
import { JobCard } from 'components/JobCard';
import { FC } from 'react';
import { NEAR_AREA_DISPLAY_NUMBER } from '@doda/common/src/services/getNearAreaJobList';
import { addComma } from '@doda/common/src/utils/convNumberUtil';
import { NearAreaDataType } from '@doda/common/src/interfaces/nearArea';
import { createJobDetailUrl } from '../JobList/logics/createJobDetailUrl';
import styles from './index.module.scss';

/**
 * NearAreaのProps
 * @param nearAreaData 近隣エリアデータ
 */
interface Props {
  nearAreaData: NearAreaDataType;
}

export const NearArea: FC<Props> = ({ nearAreaData }) => {
  const { nearAreaResponse, nearAreaUrl } = nearAreaData;
  const {
    pic = '1',
    tp,
    page = '1',
    so = '50',
  } = useSelector(appQueryParamsSelector);
  const isNoPic = pic === '0';
  const isLogin = useSelector(loginStatusSelector);

  const isShoButton =
    (nearAreaResponse.metaData?.totalCount ?? 0) >= NEAR_AREA_DISPLAY_NUMBER;

  const onClickNearAreaButton = (e) => {
    e.currentTarget.href = `${nearAreaData.nearAreaUrl}?usrclk_searchList=PC-${isLogin ? 'login' : 'logout'}JobSearchList_searchResultFooterArea_nearArea`;
  };

  return (
    <div className={styles.jobSearchList__nearArea}>
      <p className={styles.nearArea__bar}>
        近くの他エリアにはこんな求人があります
      </p>
      <div className={styles.nearArea__header}>
        <p className={styles.nearArea__header__title}>
          <span>{nearAreaData.nearAreaTitle}近隣エリア</span>の転職・求人情報
        </p>
        <p className={styles.nearArea__header__jobCount}>
          該当求人数
          <span>{addComma(nearAreaResponse.metaData?.totalCount ?? 0)}</span>件
        </p>
      </div>
      <div className={styles.nearArea__jobCardList}>
        {nearAreaResponse.results?.map((job, index) => {
          const {
            destinationURL,
            titleLink,
            imageLink,
            footerButtonLink,
            bookmarkUrlQuery,
          } = createJobDetailUrl({
            job,
            tp,
            index,
            pageCount: Number(page),
            soCount: Number(so),
            isLogin,
          });

          return (
            <div key={job.jid}>
              <JobCard
                job={job}
                isNoPic={isNoPic}
                destinationURL={destinationURL}
                onNavigateTitle={(event) => {
                  event.currentTarget.href = `${titleLink}`;
                }}
                onNavigateImage={(event) => {
                  event.currentTarget.href = `${imageLink}`;
                }}
                onNavigateFooterButton={(event) => {
                  event.currentTarget.href = `${footerButtonLink}`;
                }}
                bookmarkUrlQuery={bookmarkUrlQuery}
              />
            </div>
          );
        })}
      </div>
      {isShoButton && (
        <div className={styles.nearArea__button}>
          <Button
            as="a"
            href={nearAreaUrl}
            size="L"
            variant="outline_blue"
            onClick={(e) => onClickNearAreaButton(e)}
          >
            <span>
              <span className={styles['nearArea__button__text-L']}>
                {nearAreaData.nearAreaTitle}近隣エリア
              </span>
              の<br />
              転職・求人情報をもっと見る
              <br />
              <span className={styles['nearArea__button__text-S']}>
                ({addComma(nearAreaResponse.metaData?.totalCount ?? 0)}件)
              </span>
            </span>
          </Button>
        </div>
      )}
    </div>
  );
};
